// Use build-time optimized variant-specific code

import { CLEARTRIP, FLYIN } from '@/src/constants/buildVariants'

// This allows for tree-shaking at build time
export const VARIANT = process.env.NEXT_PUBLIC_VARIANT || 'FLYIN'

export const getLogo = () => {
    switch (VARIANT) {
        case CLEARTRIP:
            return {
                path: '/assets/png/ClearTripLogo.png',
                width: 76,
                height: 32
            }
        case FLYIN:
            return {
                path: '/assets/svgs/FlyinLogo.tsx',
                width: 76,
                height: 32
            }
        default:
            return {
                path: '/assets/svgs/FlyinLogo.tsx',
                width: 76,
                height: 32
            }
    }
}

export const getBrandName = () => {
    switch (VARIANT) {
        case CLEARTRIP:
            return 'cleartrip'
        case FLYIN:
            return 'flyin'
        default:
            return 'flyin'
    }
}
